<app-header></app-header>
<div class="container-fluid">
    <div class="row main-card-style">
            <div class="col-md-12">
                <!-- Grid row -->
                <div class="row allign-item" >
                  <!-- Grid column -->

                  <div class="mb-4">
                  <div class="color-block mb-3 mx-auto rounded-circle">{{roleCountList[7].count}}</div>
                  <h5 class="mb-0">IAM <br/>Administrator</h5>
                  <span class="ico-iam"><i class="fa fa-cogs ico-color" aria-hidden="true"></i></span>
                </div>

                <div class="mb-4">
                  <div class="color-block mb-3 mx-auto rounded-circle ">{{roleCountList[0].count}}</div>
                  <h5 class="mb-0"><br/>Scheduler</h5>
                  <span class="ico-iam"><i class="fa fa-user ico-color" aria-hidden="true"></i></span>
                </div>

                <div class="mb-4">
                  <div class="color-block mb-3 mx-auto rounded-circle">{{roleCountList[2].count}}</div>
                  <h5 class="mb-0">Nurse <br/>Practitioner</h5>
                  <span class="ico-iam"><i class="fa fa-user-md ico-color" aria-hidden="true"></i></span>
                </div>

                <div class="mb-4">
                  <div class="color-block mb-3 mx-auto rounded-circle">{{roleCountList[6].count}}</div>
                  <h5 class="mb-0">Coding <br/>Manager</h5>
                  <span class="ico-iam"><i class="fa fa-user-circle ico-color" aria-hidden="true"></i></span>
                </div>

                <div class="mb-4">
                  <div class="color-block mb-3 mx-auto rounded-circle">{{roleCountList[3].count}}</div>
                  <h5 class="mb-0">Clinical <br/>Reviewer</h5>
                  <span class="ico-iam"><i class="fa fa-user-circle ico-color" aria-hidden="true"></i></span>
                </div>

                <div class="mb-4">
                  <div class="color-block mb-3 mx-auto rounded-circle">{{roleCountList[4].count}}</div>
                  <h5 class="mb-0">Coder<br/>Level1</h5>
                  <span class="ico-iam"><i class="fa fa-user-circle ico-color" aria-hidden="true"></i></span>
                </div>

                <div class="mb-4">
                  <div class="color-block mb-3 mx-auto rounded-circle">{{roleCountList[5].count}}</div>
                  <h5 class="mb-0">Coder <br/>Level2</h5>
                  <span class="ico-iam"><i class="fa fa-user-circle ico-color" aria-hidden="true"></i></span>
                </div>

              </div>
              <!-- Grid row -->

            </div>
            <div class="col-md-12">
                  <div class="search-section">
                    <div class="col-md-3">
                      <mat-form-field appearance="none" class="manage-select">
                        <mat-select matInput (selectionChange)="onRoleChange($event)" placeholder="Select Role">
                          <mat-option value="All">All</mat-option>
                          <mat-option *ngFor="let role of searchKeys" [value]=role.name>{{role.name}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="col-md-4"></div>
                    <div class="col-md-5 row search-bx-outer">
                      <div class="col-md-8">
                          <mat-form-field class="form-control search-div" appearance="none">
                            <input class="new-sea" matInput [(ngModel)]="searchKey" (keyup)="getUsersList(undefined, true)" placeholder="Search by First Name/ Last Name/ User Id" #input>
                            <button mat-button matSuffix mat-icon-button arai-label="Clear" *ngIf="searchKey" (click)="onSearchClear()" class="mat-icon-button">
                              <mat-icon>close</mat-icon>
                            </button>
                          </mat-form-field>
                          <button mat-raised-button class="btn Action-buttons" *ngIf="!searchKey"
                        (click)="getUsersList()" style="background-color: transparent; border: none; z-index:1;
                                    box-shadow: none;
                                    position: absolute;
                                    left: 275px;
                                    top: 9px;">
                        <mat-icon>search</mat-icon>
                      </button>
                      </div>

                      <div class="col-md-4">
                        <button class="btn btn-primary btn-rounded up-password-btn" (click)="openAddUserDialog()">
                          <i class="fa fa-user-plus" aria-hidden="true"></i> Add User</button>
                      </div>
                    </div>
                  </div>
            </div>

            <div class="col-lg-12 grid-margin stretch-card paddrl35" style="padding-bottom: 20px;">
              <div class="card Member-card">
                <table mat-table matSort [dataSource]="dataSource" aria-label="Elements" class="display nowrap mat-elevation-z0" style="width:100%">

                  <!-- User ID Column -->
                  <ng-container matColumnDef="userid">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>User ID</th>
                    <td mat-cell *matCellDef="let element">{{element.userId}}</td>
                  </ng-container>

                  <!-- Employee ID Column -->
                  <ng-container matColumnDef="employeeId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Employee ID</th>
                    <td mat-cell *matCellDef="let element">{{element.employeeId}}</td>
                  </ng-container>

                  <!-- User Name Column -->
                  <ng-container matColumnDef="fullName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>User Name</th>
                    <td mat-cell *matCellDef="let element"> {{element.fullName}} </td>
                  </ng-container>

                   <!-- Email Column -->
                   <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                    <td mat-cell *matCellDef="let element">{{element.email}}</td>
                  </ng-container>

                   <!-- Last Login Column -->
                   <ng-container matColumnDef="lastLogin">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
                    <td mat-cell *matCellDef="let element">{{element.lastLogin}}</td>
                  </ng-container>

                  <!-- Last Contact IP Column -->
                  <ng-container matColumnDef="lastLoginIP">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login IP</th>
                    <td mat-cell *matCellDef="let element">{{element.lastLoginIP}}</td>
                  </ng-container>

                  <!-- Date Created Column -->
                  <ng-container matColumnDef="effectiveDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Effective Date</th>
                    <td mat-cell *matCellDef="let element">{{element.effectiveDate}}</td>
                  </ng-container>

                  <!-- Date Created Column -->
                  <ng-container matColumnDef="terminationDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Termination Date</th>
                    <td mat-cell *matCellDef="let element">{{element.terminationDate}}</td>
                  </ng-container>

                  <!-- Edit User Column -->
                  <ng-container matColumnDef="edituser">
                    <th mat-header-cell *matHeaderCellDef >Edit User</th>
                    <td mat-cell *matCellDef="let row">
                      <a [value]="row" (click)="openEditUserDialog($event,row)"><i class="far fa-edit"></i>
                      </a></td>
                  </ng-container>

                  <!-- User Status Column -->
                  <ng-container matColumnDef="userstatus">
                    <th mat-header-cell *matHeaderCellDef >User Status</th>
                    <td mat-cell *matCellDef="let row">
                      <label class="label-A"> <!-- Default switch -->
                        <div class="custom-control custom-switch">
                          <input type="checkbox" id="{{row.userId}}" name="feature{{row.userId}}" value="{{row}}" [checked]="row.isActive"
                            ([ngModel])="row.isActive" (click)="updateUserStatus($event, row)" class="custom-control-input">
                          <label class="custom-control-label" for="{{row.userId}}"></label>
                        </div>
                      </label>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                  <!-- Display loading data -->
               </table>

                <mat-paginator #paginator [showFirstLastButtons]="true" [length]="length" [pageSize]="pageSize"
                [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = getUsersList($event)"
                class="mat-paginator12 mat-paginator-sticky">
                </mat-paginator>
              </div>

            </div>

    </div>
  </div>
  <app-footer></app-footer>
